import * as yup from 'yup';
import { translate } from '../../../shared/i18n';

export const schemaFinancial = yup.object().shape({
  type: yup
    .number()
    .required(translate('financialsPage.createEdit.validation.typeRequired')),
  client_id: yup
    .string()
    .required(translate('financialsPage.createEdit.validation.clientRequired')),
  description: yup
    .string()
    .required(
      translate('financialsPage.createEdit.validation.descriptionRequired'),
    ),
  due_date: yup
    .string()
    .required(
      translate('financialsPage.createEdit.validation.dueDateRequired'),
    ),
  value: yup
    .number()
    .min(1, translate('financialsPage.createEdit.validation.valueMin'))
    .required(translate('financialsPage.createEdit.validation.valueRequired')),
  number_doc: yup
    .string()
    .required(
      translate('financialsPage.createEdit.validation.documentNumberRequired'),
    ),
});
